import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  STATUS_TEXT_SIZES,
  StatusTextSize,
  StatusTextType,
} from './status-text.model';

@Component({
  selector: 'app-status-text',
  templateUrl: './status-text.component.html',
  styleUrls: ['./status-text.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,

  standalone: false,
})
export class StatusTextComponent {
  @Input() text = '';
  @Input() type!: StatusTextType;
  @Input() size: StatusTextSize = STATUS_TEXT_SIZES.DEFAULT;

  constructor() {}

  get className() {
    const classes = this.typeClasses();

    return this.size === STATUS_TEXT_SIZES.MICRO
      ? `${classes} ${STATUS_TEXT_SIZES.MICRO}`
      : classes;
  }

  private typeClasses() {
    switch (this.type) {
      case StatusTextType.Notification: {
        return 'status-text notification';
      }
      case StatusTextType.Info: {
        return 'status-text info';
      }
      case StatusTextType.Warning: {
        return 'status-text warning';
      }
      case StatusTextType.Completed: {
        return 'status-text completed';
      }
      case StatusTextType.Failed: {
        return 'status-text failed';
      }
      case StatusTextType.Success: {
        return 'status-text success';
      }
      case StatusTextType.New: {
        return 'status-text new';
      }
      case StatusTextType.Price: {
        return 'status-text price';
      }
      case StatusTextType.White: {
        return 'status-text white';
      }
      case StatusTextType.None: {
        return 'status-text';
      }
    }
  }
}
